import { Link } from "wouter";
import { Eye, Pencil, Trash2 } from "lucide-react";
import { cn } from "@/lib/class-control";
import { ProjectStatusBadge } from "./project-status-badge";

export interface IProjectTableData {
  id: number;
  name: string;
  salicNumber: string;
  proponent: string;
  status: "Em Desenvolvimento" | "Ativo" | "Concluído" | "Cancelado";
  releaseDate: string;
}

interface ProjectTableProps {
  projects: IProjectTableData[];
  onDelete?: (id: number) => void;
}

export function ProjectTable({ projects, onDelete }: ProjectTableProps) {
  const handleDelete = (id: number) => {
    if (onDelete && confirm("Tem certeza que deseja excluir este projeto?")) {
      onDelete(id);
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-600">
            <th className="text-left p-4 text-sm font-medium text-gray-400">
              Nome do Projeto
            </th>
            <th className="text-left p-4 text-sm font-medium text-gray-400">
              Número Salic
            </th>
            <th className="text-left p-4 text-sm font-medium text-gray-400">
              Proponente
            </th>
            <th className="text-left p-4 text-sm font-medium text-gray-400">
              Status
            </th>
            <th className="text-left p-4 text-sm font-medium text-gray-400">
              Data de Lançamento
            </th>
            <th className="text-left p-4 text-sm font-medium text-gray-400">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => (
            <tr
              key={project.id}
              className={cn(
                "border-b border-gray-600/30 transition-colors",
                "hover:bg-[#1a2540]"
              )}
            >
              <td className="p-4 text-sm text-white font-medium">
                {project.name}
              </td>
              <td className="p-4 text-sm text-gray-300">
                {project.salicNumber}
              </td>
              <td className="p-4 text-sm text-gray-300">
                {project.proponent}
              </td>
              <td className="p-4">
                <ProjectStatusBadge status={project.status} />
              </td>
              <td className="p-4 text-sm text-gray-300">
                {project.releaseDate}
              </td>
              <td className="p-4">
                <div className="flex items-center gap-2">
                  <Link href={`/projetos/${project.id}`}>
                    <button
                      className={cn(
                        "p-2 rounded-lg transition-colors",
                        "hover:bg-[#2a2f4a] text-gray-400 hover:text-white"
                      )}
                      title="Visualizar"
                    >
                      <Eye className="w-4 h-4" />
                    </button>
                  </Link>
                  <Link href={`/cadastrar-projeto?id=${project.id}`}>
                    <button
                      className={cn(
                        "p-2 rounded-lg transition-colors",
                        "hover:bg-[#2a2f4a] text-gray-400 hover:text-white"
                      )}
                      title="Editar"
                    >
                      <Pencil className="w-4 h-4" />
                    </button>
                  </Link>
                  <button
                    onClick={() => handleDelete(project.id)}
                    className={cn(
                      "p-2 rounded-lg transition-colors",
                      "hover:bg-[#2a2f4a] text-gray-400 hover:text-red-500"
                    )}
                    title="Excluir"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {projects.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-400 text-sm">Nenhum projeto encontrado</p>
        </div>
      )}
    </div>
  );
}
